"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateGumballParameterSettings = exports.validateSelectionParameterSettings = exports.validateInteractionParameterSettings = exports.IInteractionParameterJsonSchema = exports.IGumballParameterJsonSchema = exports.ISelectionParameterJsonSchema = void 0;
const zod_1 = require("zod");
// #endregion Interfaces (2)
// #region Variables (7)
const IGeneralInteractionParameterJsonSchema = zod_1.z.object({
    hover: zod_1.z.boolean().optional(),
    hoverColor: zod_1.z.string().optional(),
    nameFilter: zod_1.z.array(zod_1.z.string()).optional(),
});
exports.ISelectionParameterJsonSchema = zod_1.z.object({
    type: zod_1.z.literal('selection'),
    props: zod_1.z.object({
        maximumSelection: zod_1.z.number().optional(),
        minimumSelection: zod_1.z.number().optional(),
        selectionColor: zod_1.z.string().optional(),
    }).merge(IGeneralInteractionParameterJsonSchema),
});
exports.IGumballParameterJsonSchema = zod_1.z.object({
    type: zod_1.z.literal('gumball'),
    props: zod_1.z.object({
        enableRotation: zod_1.z.boolean().optional(),
        enableScaling: zod_1.z.boolean().optional(),
        enableTranslation: zod_1.z.boolean().optional(),
        scale: zod_1.z.number().optional(),
        space: zod_1.z.literal('local').or(zod_1.z.literal('world')).optional(),
        selectionColor: zod_1.z.string().optional(),
    }).merge(IGeneralInteractionParameterJsonSchema),
});
exports.IInteractionParameterJsonSchema = exports.ISelectionParameterJsonSchema.or(exports.IGumballParameterJsonSchema);
const validateInteractionParameterSettings = (param) => {
    return exports.IInteractionParameterJsonSchema.safeParse(param);
};
exports.validateInteractionParameterSettings = validateInteractionParameterSettings;
const validateSelectionParameterSettings = (param) => {
    return exports.ISelectionParameterJsonSchema.safeParse(param);
};
exports.validateSelectionParameterSettings = validateSelectionParameterSettings;
const validateGumballParameterSettings = (param) => {
    return exports.IGumballParameterJsonSchema.safeParse(param);
};
exports.validateGumballParameterSettings = validateGumballParameterSettings;
// #endregion Variables (7)
//# sourceMappingURL=IInteractionParameterSettings.js.map